<template>
  <head>
    <meta charset="utf-8"/>
    <title>HOSPITAL MANAGEMENT INFORMATION SYSTEM</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="HMIS By Craft Silicon Payments" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
          type="text/css"/>
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <link rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
  </head>

  <body data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Departments</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="#">Organization Structure</a></li>
                    <li class="breadcrumb-item"><a href="#">Departments</a></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Ethiopian/Gregorian Date Filter Section -->
          <div class="row mb-3">
            <div class="col-12">
              <div class="card mb-0">
                <div class="card-body py-2">
                  <div class="row g-2 align-items-center">
                    <!-- Calendar Type Toggle -->
                    <div class="col-auto">
                      <div class="btn-group btn-group-sm" role="group">
                        <input type="radio" class="btn-check" name="calendarType" id="calEth" :value="true"
                               v-model="showEthiopianDates">
                        <label class="btn btn-outline-primary" for="calEth">
                          <i class="bx bx-calendar me-1"></i>Ethiopian
                        </label>
                        <input type="radio" class="btn-check" name="calendarType" id="calGreg" :value="false"
                               v-model="showEthiopianDates">
                        <label class="btn btn-outline-success" for="calGreg">
                          <i class="bx bx-calendar-alt me-1"></i>Gregorian
                        </label>
                      </div>
                    </div>

                    <!-- Date Selection -->
                    <div class="col">
                      <div class="row g-2 align-items-center">
                        <div class="col-auto">
                          <span class="badge bg-secondary">From</span>
                        </div>
                        <div class="col-auto">
                          <select v-model="dateFilterRange.fromDay" @change="updateDateRange"
                                  class="form-select form-select-sm" style="width: 65px;">
                            <option value="">{{ showEthiopianDates ? 'ቀን' : 'Day' }}</option>
                            <option v-for="d in fromDaysInMonth" :key="d" :value="d">{{ d }}</option>
                          </select>
                        </div>
                        <div class="col-auto">
                          <select v-model="dateFilterRange.fromMonth" @change="onFromMonthChange"
                                  class="form-select form-select-sm" style="width: 115px;">
                            <option value="">{{ showEthiopianDates ? 'ወር' : 'Month' }}</option>
                            <option v-for="m in displayMonths" :key="m.value" :value="m.value">
                              {{ showEthiopianDates ? m.label : m.labelShort }}
                            </option>
                          </select>
                        </div>
                        <div class="col-auto">
                          <select v-model="dateFilterRange.fromYear" @change="updateDateRange"
                                  class="form-select form-select-sm" style="width: 80px;">
                            <option value="">{{ showEthiopianDates ? 'ዓ/ም' : 'Year' }}</option>
                            <option v-for="y in displayYearOptions" :key="y" :value="y">{{ y }}</option>
                          </select>
                        </div>

                        <div class="col-auto">
                          <span class="text-muted">—</span>
                        </div>

                        <div class="col-auto">
                          <span class="badge bg-secondary">To</span>
                        </div>
                        <div class="col-auto">
                          <select v-model="dateFilterRange.toDay" @change="updateDateRange"
                                  class="form-select form-select-sm" style="width: 65px;">
                            <option value="">{{ showEthiopianDates ? 'ቀን' : 'Day' }}</option>
                            <option v-for="d in toDaysInMonth" :key="d" :value="d">{{ d }}</option>
                          </select>
                        </div>
                        <div class="col-auto">
                          <select v-model="dateFilterRange.toMonth" @change="onToMonthChange"
                                  class="form-select form-select-sm" style="width: 115px;">
                            <option value="">{{ showEthiopianDates ? 'ወር' : 'Month' }}</option>
                            <option v-for="m in displayMonths" :key="m.value" :value="m.value">
                              {{ showEthiopianDates ? m.label : m.labelShort }}
                            </option>
                          </select>
                        </div>
                        <div class="col-auto">
                          <select v-model="dateFilterRange.toYear" @change="updateDateRange"
                                  class="form-select form-select-sm" style="width: 80px;">
                            <option value="">{{ showEthiopianDates ? 'ዓ/ም' : 'Year' }}</option>
                            <option v-for="y in displayYearOptions" :key="y" :value="y">{{ y }}</option>
                          </select>
                        </div>

                        <div class="col-auto">
                          <button type="button" class="btn btn-primary btn-sm" @click="applyDateFilter"
                                  :disabled="!isValidDateRange" title="Apply Filter">
                            <i class="bx bx-filter-alt"></i>
                          </button>
                        </div>
                        <div class="col-auto" v-if="hasDateSelection">
                          <button type="button" class="btn btn-outline-danger btn-sm" @click="clearDateFilter"
                                  title="Clear Filter">
                            <i class="bx bx-x"></i>
                          </button>
                        </div>

                        <div class="col-auto ms-2">
                          <div class="btn-group btn-group-sm" role="group">
                            <button type="button" class="btn btn-outline-secondary" @click="setQuickDateRange('today')"
                                    title="Today">Today
                            </button>
                            <button type="button" class="btn btn-outline-secondary" @click="setQuickDateRange('week')"
                                    title="This Week">Week
                            </button>
                            <button type="button" class="btn btn-outline-secondary" @click="setQuickDateRange('month')"
                                    title="This Month">Month
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-2" v-if="alternateDateDisplay">
                    <div class="col-12">
                      <small :class="showEthiopianDates ? 'text-success' : 'text-primary'">
                        <i class="bx bx-calendar-check me-1"></i>
                        <strong>{{ showEthiopianDates ? 'Gregorian' : 'Ethiopian' }}:</strong>
                        {{ alternateDateDisplay }}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div
                    class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <h4 class="card-title text-uppercase mb-0">All Available Departments</h4>
                    <div class="d-flex">
                      <button @click="showCreateModal" type="button"
                              class="btn btn-primary waves-effect btn-label waves-light text-uppercase">
                        <i class="bx bx-plus label-icon"></i> New Department
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-header bg-white border-bottom py-3">
                  <div class="btn-toolbar d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="d-flex align-items-center gap-3">
                      <!-- Per Page Selector -->
                      <div class="d-flex align-items-center">
                        <label class="me-2 text-nowrap small">Show</label>
                        <select class="form-select form-select-sm" style="width: 80px;" v-model="perPage"
                                @change="onPerPageChange">
                          <option :value="10">10</option>
                          <option :value="25">25</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                        <label class="ms-2 text-nowrap small">entries</label>
                      </div>

                      <!-- Search Box -->
                      <div class="search-box mb-0">
                        <div class="position-relative">
                          <input v-model="filters.searchTerm" @input="handleSearch" type="text"
                                 class="form-control bg-light border-light rounded" placeholder="Search..."
                                 spellcheck="false">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>

                      <!-- Refresh Button -->
                      <button type="button" class="btn btn-sm btn-outline-secondary" @click="refreshData"
                              :disabled="loading">
                        <i class="bx bx-refresh" :class="{'bx-spin': loading}"></i>
                      </button>
                    </div>

                    <div class="d-flex">
                      <div class="d-flex align-items-center">
                        <div class="input-group fw-semibold text-uppercase">
                          <label class="input-group-text text-uppercase">Status</label>
                          <select v-model="filters.status" @change="onFilterChange" class="form-select">
                            <option value="">All Statuses</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Loading state -->
                  <div v-if="loading" class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <p class="mt-2">Loading departments...</p>
                  </div>

                  <!-- Table -->
                  <div v-else class="table-responsive">
                    <table class="table align-middle table-hover contacts-table text-uppercase border">
                      <thead class="table-light">
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Name</th>
                        <th scope="col">Abr</th>
                        <th scope="col">Is Clinic</th>
                        <th scope="col">Employees Count</th>
                        <th scope="col">Manager</th>
                        <th scope="col">Status</th>
                        <th>Last Updated</th>
                        <th class="text-right">Actions</th>
                      </tr>
                      </thead>
                      <tbody class="border">
                      <tr v-for="(department, index) in departments" :key="department.department_id">
                        <td>{{ getRowNumber(index) }}.</td>
                        <td>{{ department.department_name }}</td>
                        <td>{{ department.abbreviation }}</td>
                        <td>{{ department.is_clinic == 1 ? 'Yes' : 'No' }}</td>
                        <td>{{ department.employee_count || 0 }}</td>
                        <td>{{ department.manager_name || 'N/A' }}</td>
                        <td class="fw-bold text-black">
                          <p class="mb-2 text-truncate">
                            <i :class="getStatusIcon(department.status)"></i> {{ formatStatus(department.status) }}
                          </p>
                        </td>
                        <td>{{ formatDateDisplay(department.updated_at) }}</td>
                        <td class="text-uppercase text-right">
                          <div class="d-flex justify-content-end">
                            <button @click="editDepartment(department)" class="btn btn-sm btn-success text-uppercase"
                                    title="Edit Department">Edit
                            </button>
                            <button @click="showDetailsModal(department)"
                                    class="btn btn-sm btn-info text-uppercase mx-2" title="View Details">Details
                            </button>
                            <button v-if="department.status === 'active'" @click="showDeactivateModal(department)"
                                    class="btn btn-sm btn-danger text-uppercase" title="Deactivate">Deactivate
                            </button>
                            <button v-else @click="activateDepartment(department)"
                                    class="btn btn-sm btn-primary text-uppercase" title="Activate">Activate
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Empty state -->
                    <div v-if="departments.length === 0" class="text-center py-4">
                      <p class="text-muted">No departments found</p>
                    </div>

                    <!-- Pagination -->
                    <div class="d-flex justify-content-between align-items-center mt-3" v-if="pagination.total > 0">
                      <div class="text-muted small">
                        Showing {{ showingFrom }} to {{ showingTo }} of {{ pagination.total }} entries
                      </div>
                      <nav aria-label="Page navigation">
                        <ul class="pagination pagination-sm mb-0">
                          <li class="page-item" :class="{ disabled: pagination.current_page === 1 }">
                            <a class="page-link" href="#" @click.prevent="goToPage(1)" title="First">
                              <i class="bx bx-chevrons-left"></i>
                            </a>
                          </li>
                          <li class="page-item" :class="{ disabled: pagination.current_page === 1 }">
                            <a class="page-link" href="#" @click.prevent="previousPage" title="Previous">
                              <i class="bx bx-chevron-left"></i>
                            </a>
                          </li>
                          <li class="page-item" v-for="page in visiblePages" :key="page"
                              :class="{ active: page === pagination.current_page }">
                            <a class="page-link" href="#" @click.prevent="goToPage(page)">{{ page }}</a>
                          </li>
                          <li class="page-item"
                              :class="{ disabled: pagination.current_page === pagination.total_pages }">
                            <a class="page-link" href="#" @click.prevent="nextPage" title="Next">
                              <i class="bx bx-chevron-right"></i>
                            </a>
                          </li>
                          <li class="page-item"
                              :class="{ disabled: pagination.current_page === pagination.total_pages }">
                            <a class="page-link" href="#" @click.prevent="goToPage(pagination.total_pages)"
                               title="Last">
                              <i class="bx bx-chevrons-right"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Create Modal -->
      <div v-if="showCreate" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content modal-md">
            <div class="modal-header border-bottom-0">
              <h4 class="modal-title text-uppercase">Create New Department</h4>
              <button type="button" class="btn-close" @click="closeCreateModal"></button>
            </div>
            <div class="modal-body">
              <div v-if="alert.show" :class="`alert alert-${alert.type}`" role="alert">{{ alert.message }}</div>

              <div class="row">
                <div class="col-6 mb-3">
                  <label for="department-name" class="form-label">Department Name<strong
                      class="text-danger fw-bold">*</strong></label>
                  <input v-model="form.departmentName" type="text" class="form-control" id="department-name"
                         placeholder="Enter Department Name" required>
                </div>

                <div class="col-6 mb-3">
                  <label for="abbreviation" class="form-label">Abbreviation<strong
                      class="text-danger fw-bold">*</strong></label>
                  <input v-model="form.abbreviation" type="text" class="form-control" id="abbreviation"
                         placeholder="Enter Abbreviation" required>
                </div>

                <div class="col-6 mb-3">
                  <label for="assigned-manager" class="form-label">Assigned Manager</label>
                  <input v-model="form.managerName" type="text" class="form-control" id="assigned-manager"
                         placeholder="Enter Manager Name">
                </div>

                <div class="col-6 mb-3">
                  <label for="status" class="form-label">Status<strong class="text-danger fw-bold">*</strong></label>
                  <select v-model="form.status" id="status" class="form-select" required>
                    <option value="" disabled>Select Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>

                <div class="col-12 mb-3">
                  <label class="form-label">Is this a Clinic?<strong class="text-danger fw-bold">*</strong></label>
                  <div>
                    <div class="form-check">
                      <input v-model="form.isClinic" class="form-check-input" type="radio" name="clinic-option"
                             id="clinic-yes" :value="1" required>
                      <label class="form-check-label" for="clinic-yes">Yes</label>
                    </div>
                    <div class="form-check">
                      <input v-model="form.isClinic" class="form-check-input" type="radio" name="clinic-option"
                             id="clinic-no" :value="0" checked>
                      <label class="form-check-label" for="clinic-no">No</label>
                    </div>
                  </div>
                </div>

                <div class="col-12 mb-3">
                  <label for="description" class="form-label">Department Description</label>
                  <textarea v-model="form.description" id="description" placeholder="Enter Description"
                            class="form-control" rows="3"></textarea>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex flex-wrap gap-2 text-uppercase">
                <button @click="createDepartment" :disabled="createLoading" type="submit"
                        class="btn btn-primary waves-effect waves-light">
                  <span v-if="createLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                  {{ createLoading ? 'Saving...' : 'Save' }}
                </button>
                <button @click="closeCreateModal" type="button" class="btn btn-secondary waves-effect">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Edit Modal -->
      <div v-if="showEdit" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content modal-md">
            <div class="modal-header border-bottom-0">
              <h4 class="modal-title text-uppercase">Edit Department</h4>
              <button type="button" class="btn-close" @click="closeEditModal"></button>
            </div>
            <div class="modal-body">
              <div v-if="alert.show" :class="`alert alert-${alert.type}`" role="alert">{{ alert.message }}</div>

              <div class="row">
                <div class="col-6 mb-3">
                  <label for="edit-department-name" class="form-label">Department Name<strong
                      class="text-danger fw-bold">*</strong></label>
                  <input v-model="editForm.departmentName" type="text" class="form-control" id="edit-department-name">
                </div>

                <div class="col-6 mb-3">
                  <label for="edit-abbreviation" class="form-label">Abbreviation<strong
                      class="text-danger fw-bold">*</strong></label>
                  <input v-model="editForm.abbreviation" type="text" class="form-control" id="edit-abbreviation">
                </div>

                <div class="col-6 mb-3">
                  <label for="edit-assigned-manager" class="form-label">Assigned Manager</label>
                  <input v-model="editForm.managerName" type="text" class="form-control" id="edit-assigned-manager">
                </div>

                <div class="col-6 mb-3">
                  <label for="edit-status" class="form-label">Status<strong
                      class="text-danger fw-bold">*</strong></label>
                  <select v-model="editForm.status" id="edit-status" class="form-select">
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>

                <div class="col-12 mb-3">
                  <label class="form-label">Is this a Clinic?<strong class="text-danger fw-bold">*</strong></label>
                  <div>
                    <div class="form-check">
                      <input v-model="editForm.isClinic" class="form-check-input" type="radio" name="edit-clinic-option"
                             id="edit-clinic-yes" :value="1">
                      <label class="form-check-label" for="edit-clinic-yes">Yes</label>
                    </div>
                    <div class="form-check">
                      <input v-model="editForm.isClinic" class="form-check-input" type="radio" name="edit-clinic-option"
                             id="edit-clinic-no" :value="0">
                      <label class="form-check-label" for="edit-clinic-no">No</label>
                    </div>
                  </div>
                </div>

                <div class="col-12 mb-3">
                  <label for="edit-description" class="form-label">Department Description</label>
                  <textarea v-model="editForm.description" id="edit-description" class="form-control"
                            rows="3"></textarea>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex flex-wrap gap-2 text-uppercase">
                <button @click="updateDepartment" :disabled="editLoading" type="submit"
                        class="btn btn-primary waves-effect waves-light">
                  <span v-if="editLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                  {{ editLoading ? 'Saving...' : 'Save Changes' }}
                </button>
                <button @click="closeEditModal" type="button" class="btn btn-secondary waves-effect">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Details Modal -->
      <div v-if="showDetails" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title text-uppercase">Department Details</h4>
              <button type="button" class="btn-close" @click="closeDetailsModal"></button>
            </div>
            <div class="modal-body">
              <div v-if="detailsLoading" class="text-center py-4">
                <div class="spinner-border text-primary" role="status"></div>
              </div>

              <div v-else-if="selectedDepartment" class="row">
                <div class="col-md-6 mb-3">
                  <label class="text-muted">Department Name</label>
                  <p class="fw-bold">{{ selectedDepartment.department_name }}</p>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="text-muted">Abbreviation</label>
                  <p class="fw-bold">{{ selectedDepartment.abbreviation }}</p>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="text-muted">Status</label>
                  <p class="fw-bold">
                    <span :class="selectedDepartment.status === 'active' ? 'text-success' : 'text-danger'">
                      {{ formatStatus(selectedDepartment.status) }}
                    </span>
                  </p>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="text-muted">Is Clinic</label>
                  <p class="fw-bold">{{ selectedDepartment.is_clinic == 1 ? 'Yes' : 'No' }}</p>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="text-muted">Manager</label>
                  <p class="fw-bold">{{ selectedDepartment.manager_name || 'Not Assigned' }}</p>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="text-muted">Employee Count</label>
                  <p class="fw-bold">
                    {{ selectedDepartment.actual_employee_count || selectedDepartment.employee_count || 0 }}</p>
                </div>

                <div class="col-12 mb-3">
                  <label class="text-muted">Description</label>
                  <p class="fw-bold">{{ selectedDepartment.description || 'No description available' }}</p>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="text-muted">Created By</label>
                  <p class="fw-bold">{{ selectedDepartment.created_by_name }} {{
                      selectedDepartment.created_by_lastname
                    }}</p>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="text-muted">Created At</label>
                  <p class="fw-bold">{{ formatDateDisplay(selectedDepartment.created_at) }}</p>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="text-muted">Last Updated</label>
                  <p class="fw-bold">{{ formatDateDisplay(selectedDepartment.updated_at) }}</p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary text-uppercase" @click="closeDetailsModal">Close</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Deactivate Modal -->
      <div v-if="showDeactivate" class="modal fade show d-block" tabindex="-1"
           style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content modal-md">
            <div class="modal-header border-bottom-0">
              <h4 class="modal-title text-uppercase">Deactivate Department</h4>
              <button type="button" class="btn-close" @click="closeDeactivateModal"></button>
            </div>
            <div class="modal-body">
              <div v-if="alert.show" :class="`alert alert-${alert.type}`" role="alert">{{ alert.message }}</div>

              <p>Are you sure you want to deactivate the department <strong
                  class="text-primary">{{ selectedDepartment?.department_name }}</strong>?</p>
              <div class="row">
                <div class="col-12 mb-3">
                  <label for="deactivation-reason" class="form-label">Reason for Deactivation (Optional)</label>
                  <textarea v-model="deactivateReason" id="deactivation-reason"
                            placeholder="Provide reason for deactivation" class="form-control" rows="3"></textarea>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex flex-wrap gap-2 text-uppercase">
                <button @click="deactivateDepartment" :disabled="deactivateLoading" type="submit"
                        class="btn btn-danger waves-effect waves-light">
                  <span v-if="deactivateLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                  {{ deactivateLoading ? 'Processing...' : 'Confirm Deactivation' }}
                </button>
                <button @click="closeDeactivateModal" type="button" class="btn btn-secondary waves-effect">Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">© Hospital Management Information System</div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">2024</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import {authUrl, executeJson} from "@/api";

export default {
  name: "Departments",
  components: {NavigationBar},
  data() {
    return {
      loading: false, createLoading: false, editLoading: false, deactivateLoading: false, detailsLoading: false,
      showCreate: false, showEdit: false, showDeactivate: false, showDetails: false,
      departments: [], selectedDepartment: null, deactivateReason: '',
      perPage: 10, currentPage: 1,
      pagination: {total: 0, per_page: 10, current_page: 1, total_pages: 1, offset: 0, has_more: false},
      filters: {searchTerm: '', status: '', startDate: '', endDate: ''},
      searchTimeout: null,
      form: {departmentName: '', abbreviation: '', managerName: '', status: 'active', isClinic: 0, description: ''},
      editForm: {
        departmentId: '',
        departmentName: '',
        abbreviation: '',
        managerName: '',
        status: '',
        isClinic: 0,
        description: ''
      },
      alert: {show: false, type: 'success', message: ''},

      // Ethiopian Calendar State
      showEthiopianDates: true,
      currentEthiopianDate: {year: 2017, month: 3, day: 15, monthName: 'ህዳር', monthNameEn: 'Hidar'},
      dateFilterRange: {fromDay: '', fromMonth: '', fromYear: '', toDay: '', toMonth: '', toYear: ''},

      ethiopianMonths: [
        {value: 1, label: 'መስከረም', labelEn: 'Meskerem'}, {value: 2, label: 'ጥቅምት', labelEn: 'Tikimt'},
        {value: 3, label: 'ህዳር', labelEn: 'Hidar'}, {value: 4, label: 'ታህሳስ', labelEn: 'Tahsas'},
        {value: 5, label: 'ጥር', labelEn: 'Tir'}, {value: 6, label: 'የካቲት', labelEn: 'Yekatit'},
        {value: 7, label: 'መጋቢት', labelEn: 'Megabit'}, {value: 8, label: 'ሚያዝያ', labelEn: 'Miyazya'},
        {value: 9, label: 'ግንቦት', labelEn: 'Ginbot'}, {value: 10, label: 'ሰኔ', labelEn: 'Sene'},
        {value: 11, label: 'ሐምሌ', labelEn: 'Hamle'}, {value: 12, label: 'ነሐሴ', labelEn: 'Nehase'},
        {value: 13, label: 'ጳጉሜ', labelEn: 'Pagume'}
      ],
      gregorianMonths: [
        {value: 1, label: 'January', labelShort: 'Jan'}, {value: 2, label: 'February', labelShort: 'Feb'},
        {value: 3, label: 'March', labelShort: 'Mar'}, {value: 4, label: 'April', labelShort: 'Apr'},
        {value: 5, label: 'May', labelShort: 'May'}, {value: 6, label: 'June', labelShort: 'Jun'},
        {value: 7, label: 'July', labelShort: 'Jul'}, {value: 8, label: 'August', labelShort: 'Aug'},
        {value: 9, label: 'September', labelShort: 'Sep'}, {value: 10, label: 'October', labelShort: 'Oct'},
        {value: 11, label: 'November', labelShort: 'Nov'}, {value: 12, label: 'December', labelShort: 'Dec'}
      ]
    };
  },

  computed: {
    showingFrom() {
      if (this.pagination.total === 0) return 0;
      return (this.pagination.current_page - 1) * this.pagination.per_page + 1;
    },
    showingTo() {
      const to = this.pagination.current_page * this.pagination.per_page;
      return Math.min(to, this.pagination.total);
    },
    visiblePages() {
      const totalPages = this.pagination.total_pages, current = this.pagination.current_page, pages = [];
      if (totalPages <= 5) {
        for (let i = 1; i <= totalPages; i++) pages.push(i);
      } else {
        let start = Math.max(1, current - 2), end = Math.min(totalPages, current + 2);
        if (current <= 3) end = 5;
        if (current >= totalPages - 2) start = totalPages - 4;
        for (let i = start; i <= end; i++) pages.push(i);
      }
      return pages;
    },
    ethiopianYearOptions() {
      const years = [];
      for (let y = this.currentEthiopianDate.year - 20; y <= this.currentEthiopianDate.year + 5; y++) years.push(y);
      return years;
    },
    gregorianYearOptions() {
      const cy = new Date().getFullYear(), years = [];
      for (let y = cy - 20; y <= cy + 5; y++) years.push(y);
      return years;
    },
    displayMonths() {
      return this.showEthiopianDates ? this.ethiopianMonths : this.gregorianMonths;
    },
    displayYearOptions() {
      return this.showEthiopianDates ? this.ethiopianYearOptions : this.gregorianYearOptions;
    },
    fromDaysInMonth() {
      return this.showEthiopianDates ? this.getDaysInEthiopianMonth(this.dateFilterRange.fromMonth, this.dateFilterRange.fromYear) : this.getDaysInGregorianMonth(this.dateFilterRange.fromMonth, this.dateFilterRange.fromYear);
    },
    toDaysInMonth() {
      return this.showEthiopianDates ? this.getDaysInEthiopianMonth(this.dateFilterRange.toMonth, this.dateFilterRange.toYear) : this.getDaysInGregorianMonth(this.dateFilterRange.toMonth, this.dateFilterRange.toYear);
    },
    hasDateSelection() {
      return (this.dateFilterRange.fromDay && this.dateFilterRange.fromMonth && this.dateFilterRange.fromYear) || (this.dateFilterRange.toDay && this.dateFilterRange.toMonth && this.dateFilterRange.toYear);
    },
    isValidDateRange() {
      return this.dateFilterRange.fromDay && this.dateFilterRange.fromMonth && this.dateFilterRange.fromYear && this.dateFilterRange.toDay && this.dateFilterRange.toMonth && this.dateFilterRange.toYear;
    },
    alternateDateDisplay() {
      if (!this.isValidDateRange) return '';
      if (this.showEthiopianDates) {
        const fromGreg = this.ethiopianToGregorian(parseInt(this.dateFilterRange.fromYear), parseInt(this.dateFilterRange.fromMonth), parseInt(this.dateFilterRange.fromDay));
        const toGreg = this.ethiopianToGregorian(parseInt(this.dateFilterRange.toYear), parseInt(this.dateFilterRange.toMonth), parseInt(this.dateFilterRange.toDay));
        if (!fromGreg || !toGreg) return '';
        const fmt = (d) => d.toLocaleDateString('en-US', {month: 'short', day: 'numeric', year: 'numeric'});
        return `${fmt(fromGreg)} — ${fmt(toGreg)}`;
      } else {
        const fromEth = this.gregorianToEthiopian(new Date(parseInt(this.dateFilterRange.fromYear), parseInt(this.dateFilterRange.fromMonth) - 1, parseInt(this.dateFilterRange.fromDay)));
        const toEth = this.gregorianToEthiopian(new Date(parseInt(this.dateFilterRange.toYear), parseInt(this.dateFilterRange.toMonth) - 1, parseInt(this.dateFilterRange.toDay)));
        if (!fromEth || !toEth) return '';
        return `${fromEth.monthNameEn} ${fromEth.day}, ${fromEth.year} — ${toEth.monthNameEn} ${toEth.day}, ${toEth.year}`;
      }
    }
  },

  watch: {
    showEthiopianDates() {
      this.dateFilterRange = {fromDay: '', fromMonth: '', fromYear: '', toDay: '', toMonth: '', toYear: ''};
    }
  },

  mounted() {
    this.currentEthiopianDate = this.getCurrentEthiopianDate();
    this.fetchDepartments();
  },

  methods: {
    // Ethiopian Calendar Methods
    getDaysInEthiopianMonth(month, year) {
      if (!month || !year) return 30;
      const m = parseInt(month), y = parseInt(year);
      if (m === 13) return (y % 4 === 3) ? 6 : 5;
      return 30;
    },
    getDaysInGregorianMonth(month, year) {
      if (!month || !year) return 31;
      const m = parseInt(month), y = parseInt(year);
      if ([1, 3, 5, 7, 8, 10, 12].includes(m)) return 31;
      if ([4, 6, 9, 11].includes(m)) return 30;
      if (m === 2) return ((y % 4 === 0 && y % 100 !== 0) || (y % 400 === 0)) ? 29 : 28;
      return 31;
    },
    ethiopianToGregorian(ethYear, ethMonth, ethDay) {
      const EPOCH = 1724221;
      const jdn = EPOCH + 365 * (ethYear - 1) + Math.floor(ethYear / 4) + 30 * (ethMonth - 1) + ethDay - 1;
      const a = jdn + 32044;
      const b = Math.floor((4 * a + 3) / 146097);
      const c = a - Math.floor(146097 * b / 4);
      const d = Math.floor((4 * c + 3) / 1461);
      const e = c - Math.floor(1461 * d / 4);
      const m = Math.floor((5 * e + 2) / 153);
      return new Date(100 * b + d - 4800 + Math.floor(m / 10), m + 3 - 12 * Math.floor(m / 10) - 1, e - Math.floor((153 * m + 2) / 5) + 1);
    },
    gregorianToEthiopian(gregDate) {
      const date = typeof gregDate === 'string' ? new Date(gregDate) : gregDate;
      if (!date || isNaN(date.getTime())) return null;
      const gYear = date.getFullYear(), gMonth = date.getMonth() + 1, gDay = date.getDate();
      const a = Math.floor((14 - gMonth) / 12);
      const y = gYear + 4800 - a;
      const m = gMonth + 12 * a - 3;
      const jdn = gDay + Math.floor((153 * m + 2) / 5) + 365 * y + Math.floor(y / 4) - Math.floor(y / 100) + Math.floor(y / 400) - 32045;
      const EPOCH = 1724221;
      const r = (jdn - EPOCH) % 1461;
      const n = r % 365 + 365 * Math.floor(r / 1460);
      const ethYear = 4 * Math.floor((jdn - EPOCH) / 1461) + Math.floor(r / 365) - Math.floor(r / 1460) + 1;
      const ethMonth = Math.floor(n / 30) + 1;
      const ethDay = n % 30 + 1;
      const monthData = this.ethiopianMonths.find(mon => mon.value === ethMonth);
      return {
        year: ethYear,
        month: ethMonth,
        day: ethDay,
        monthName: monthData?.label || '',
        monthNameEn: monthData?.labelEn || ''
      };
    },
    getCurrentEthiopianDate() {
      return this.gregorianToEthiopian(new Date());
    },
    formatDateDisplay(dateString) {
      if (!dateString) return 'N/A';
      if (this.showEthiopianDates) {
        const eth = this.gregorianToEthiopian(dateString);
        if (eth) return `${eth.monthNameEn} ${eth.day}, ${eth.year}`;
      }
      const d = new Date(dateString);
      return d.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    onFromMonthChange() {
      if (this.dateFilterRange.fromDay > this.fromDaysInMonth) this.dateFilterRange.fromDay = this.fromDaysInMonth;
      this.updateDateRange();
    },
    onToMonthChange() {
      if (this.dateFilterRange.toDay > this.toDaysInMonth) this.dateFilterRange.toDay = this.toDaysInMonth;
      this.updateDateRange();
    },
    updateDateRange() {
      if (this.dateFilterRange.fromDay && this.dateFilterRange.fromMonth && this.dateFilterRange.fromYear) {
        let fromGreg = this.showEthiopianDates ? this.ethiopianToGregorian(parseInt(this.dateFilterRange.fromYear), parseInt(this.dateFilterRange.fromMonth), parseInt(this.dateFilterRange.fromDay)) : new Date(parseInt(this.dateFilterRange.fromYear), parseInt(this.dateFilterRange.fromMonth) - 1, parseInt(this.dateFilterRange.fromDay));
        if (fromGreg) this.filters.startDate = fromGreg.toISOString().split('T')[0];
      }
      if (this.dateFilterRange.toDay && this.dateFilterRange.toMonth && this.dateFilterRange.toYear) {
        let toGreg = this.showEthiopianDates ? this.ethiopianToGregorian(parseInt(this.dateFilterRange.toYear), parseInt(this.dateFilterRange.toMonth), parseInt(this.dateFilterRange.toDay)) : new Date(parseInt(this.dateFilterRange.toYear), parseInt(this.dateFilterRange.toMonth) - 1, parseInt(this.dateFilterRange.toDay));
        if (toGreg) this.filters.endDate = toGreg.toISOString().split('T')[0];
      }
    },
    applyDateFilter() {
      if (this.isValidDateRange) {
        this.updateDateRange();
        this.resetPagination();
        this.fetchDepartments();
      }
    },
    clearDateFilter() {
      this.dateFilterRange = {fromDay: '', fromMonth: '', fromYear: '', toDay: '', toMonth: '', toYear: ''};
      this.filters.startDate = '';
      this.filters.endDate = '';
      this.resetPagination();
      this.fetchDepartments();
    },
    setQuickDateRange(period) {
      const today = new Date();
      let startDate = new Date(), endDate = new Date();
      switch (period) {
        case 'today':
          startDate = new Date();
          break;
        case 'week':
          startDate.setDate(today.getDate() - 7);
          break;
        case 'month':
          startDate.setDate(1);
          break;
      }
      this.filters.startDate = startDate.toISOString().split('T')[0];
      this.filters.endDate = endDate.toISOString().split('T')[0];
      if (this.showEthiopianDates) {
        const sE = this.gregorianToEthiopian(startDate), eE = this.gregorianToEthiopian(endDate);
        if (sE && eE) this.dateFilterRange = {
          fromDay: sE.day,
          fromMonth: sE.month,
          fromYear: sE.year,
          toDay: eE.day,
          toMonth: eE.month,
          toYear: eE.year
        };
      } else this.dateFilterRange = {
        fromDay: startDate.getDate(),
        fromMonth: startDate.getMonth() + 1,
        fromYear: startDate.getFullYear(),
        toDay: endDate.getDate(),
        toMonth: endDate.getMonth() + 1,
        toYear: endDate.getFullYear()
      };
      this.resetPagination();
      this.fetchDepartments();
    },

    // Pagination & Data Methods
    getRowNumber(index) {
      return (this.pagination.current_page - 1) * this.pagination.per_page + index + 1;
    },
    resetPagination() {
      this.currentPage = 1;
      this.pagination = {total: 0, per_page: this.perPage, current_page: 1, total_pages: 1, offset: 0, has_more: false};
    },
    previousPage() {
      if (this.pagination.current_page > 1) this.goToPage(this.pagination.current_page - 1);
    },
    nextPage() {
      if (this.pagination.current_page < this.pagination.total_pages) this.goToPage(this.pagination.current_page + 1);
    },
    goToPage(page) {
      if (page < 1 || page > this.pagination.total_pages) return;
      this.currentPage = page;
      this.fetchDepartments();
    },
    onPerPageChange() {
      this.resetPagination();
      this.fetchDepartments();
    },
    onFilterChange() {
      this.resetPagination();
      this.fetchDepartments();
    },
    handleSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.resetPagination();
        this.fetchDepartments();
      }, 300);
    },
    refreshData() {
      this.filters.searchTerm = '';
      this.resetPagination();
      this.fetchDepartments();
    },

    async fetchDepartments() {
      this.loading = true;
      this.clearAlert();
      const offset = (this.currentPage - 1) * this.perPage;
      const data = {
        function: "getDepartments",
        status: this.filters.status,
        searchTerm: this.filters.searchTerm,
        startDate: this.filters.startDate,
        endDate: this.filters.endDate,
        limit: this.perPage,
        offset: offset
      };
      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success) {
          this.departments = response.data.data.departments || [];
          this.pagination = response.data.data.pagination || this.pagination;
        } else {
          this.showAlertMsg('danger', response.data.message || 'Failed to fetch departments');
        }
      } catch (error) {
        this.showAlertMsg('danger', error.message || 'An error occurred while fetching departments');
      } finally {
        this.loading = false;
      }
    },

    showCreateModal() {
      this.showCreate = true;
      this.clearAlert();
      this.resetForm();
    },
    closeCreateModal() {
      this.showCreate = false;
      this.clearAlert();
      this.resetForm();
    },
    resetForm() {
      this.form = {
        departmentName: '',
        abbreviation: '',
        managerName: '',
        status: 'active',
        isClinic: 0,
        description: ''
      };
    },

    async createDepartment() {
      if (!this.form.departmentName || !this.form.abbreviation) {
        this.showAlertMsg('danger', 'Department name and abbreviation are required');
        return;
      }
      this.createLoading = true;
      this.clearAlert();
      const data = {
        function: "createDepartment",
        departmentName: this.form.departmentName,
        abbreviation: this.form.abbreviation,
        managerName: this.form.managerName,
        status: this.form.status,
        isClinic: this.form.isClinic,
        description: this.form.description
      };
      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success) {
          this.showAlertMsg('success', response.data.message || 'Department created successfully');
          setTimeout(() => {
            this.closeCreateModal();
            this.fetchDepartments();
          }, 2000);
        } else {
          this.showAlertMsg('danger', response.data.message || 'Failed to create department');
        }
      } catch (error) {
        this.showAlertMsg('danger', error.message || 'An error occurred while creating department');
      } finally {
        this.createLoading = false;
      }
    },

    editDepartment(department) {
      this.selectedDepartment = department;
      this.editForm = {
        departmentId: department.department_id,
        departmentName: department.department_name,
        abbreviation: department.abbreviation,
        managerName: department.manager_name || '',
        status: department.status,
        isClinic: parseInt(department.is_clinic),
        description: department.description || ''
      };
      this.showEdit = true;
      this.clearAlert();
    },
    closeEditModal() {
      this.showEdit = false;
      this.clearAlert();
      this.selectedDepartment = null;
    },

    async updateDepartment() {
      if (!this.editForm.departmentName || !this.editForm.abbreviation) {
        this.showAlertMsg('danger', 'Department name and abbreviation are required');
        return;
      }
      this.editLoading = true;
      this.clearAlert();
      const data = {
        function: "updateDepartment",
        departmentId: this.editForm.departmentId,
        departmentName: this.editForm.departmentName,
        abbreviation: this.editForm.abbreviation,
        managerName: this.editForm.managerName,
        status: this.editForm.status,
        isClinic: this.editForm.isClinic,
        description: this.editForm.description
      };
      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success) {
          this.showAlertMsg('success', response.data.message || 'Department updated successfully');
          setTimeout(() => {
            this.closeEditModal();
            this.fetchDepartments();
          }, 2000);
        } else {
          this.showAlertMsg('danger', response.data.message || 'Failed to update department');
        }
      } catch (error) {
        this.showAlertMsg('danger', error.message || 'An error occurred while updating department');
      } finally {
        this.editLoading = false;
      }
    },

    async showDetailsModal(department) {
      this.showDetails = true;
      this.detailsLoading = true;
      this.selectedDepartment = null;
      const data = {function: "getDepartmentDetails", departmentId: department.department_id};
      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success) {
          this.selectedDepartment = response.data.data.department;
        } else {
          this.showAlertMsg('danger', response.data.message || 'Failed to fetch department details');
        }
      } catch (error) {
        this.showAlertMsg('danger', error.message || 'An error occurred while fetching department details');
      } finally {
        this.detailsLoading = false;
      }
    },

    closeDetailsModal() {
      this.showDetails = false;
      this.selectedDepartment = null;
    },
    showDeactivateModal(department) {
      this.selectedDepartment = department;
      this.showDeactivate = true;
      this.clearAlert();
      this.deactivateReason = '';
    },
    closeDeactivateModal() {
      this.showDeactivate = false;
      this.clearAlert();
      this.selectedDepartment = null;
      this.deactivateReason = '';
    },

    async deactivateDepartment() {
      this.deactivateLoading = true;
      this.clearAlert();
      const data = {
        function: "deactivateDepartment",
        departmentId: this.selectedDepartment.department_id,
        reason: this.deactivateReason
      };
      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success) {
          this.showAlertMsg('success', response.data.message || 'Department deactivated successfully');
          setTimeout(() => {
            this.closeDeactivateModal();
            this.fetchDepartments();
          }, 2000);
        } else {
          this.showAlertMsg('danger', response.data.message || 'Failed to deactivate department');
        }
      } catch (error) {
        this.showAlertMsg('danger', error.message || 'An error occurred while deactivating department');
      } finally {
        this.deactivateLoading = false;
      }
    },

    async activateDepartment(department) {
      if (confirm(`Are you sure you want to activate ${department.department_name}?`)) {
        const data = {function: "updateDepartment", departmentId: department.department_id, status: 'active'};
        try {
          const response = await executeJson(data, authUrl);
          if (response.data.success) {
            this.showAlertMsg('success', 'Department activated successfully');
            this.fetchDepartments();
          } else {
            this.showAlertMsg('danger', response.data.message || 'Failed to activate department');
          }
        } catch (error) {
          this.showAlertMsg('danger', error.message || 'An error occurred while activating department');
        }
      }
    },

    formatStatus(status) {
      return status.charAt(0).toUpperCase() + status.slice(1);
    },
    getStatusIcon(status) {
      const icons = {'active': 'mdi mdi-circle text-success me-1', 'inactive': 'mdi mdi-circle text-danger me-1'};
      return icons[status] || 'mdi mdi-circle text-secondary me-1';
    },
    showAlertMsg(type, message) {
      this.alert = {show: true, type: type, message: message};
      if (type === 'success') {
        setTimeout(() => {
          this.clearAlert();
        }, 5000);
      }
    },
    clearAlert() {
      this.alert = {show: false, type: 'success', message: ''};
    }
  }
};
</script>

<style scoped>
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.modal.show {
  display: block !important;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.search-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: #74788d;
}

.pagination {
  margin-bottom: 0;
}

.page-link {
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
}

.page-item.active .page-link {
  background-color: #5664d2;
  border-color: #5664d2;
}

.gap-3 {
  gap: 1rem;
}

.bx-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.btn-check:checked + .btn-outline-primary {
  background-color: #0d6efd;
  color: white;
}

.btn-check:checked + .btn-outline-success {
  background-color: #198754;
  color: white;
}
</style>